/*
 * File: DatabasePreferences.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: List of all the different database preferences
 */
import PreferencesApi from "./Api";

const DatabasePreferences = {
  async fetch(keys) {
    return await PreferencesApi.fetch(keys);
  },

  async update(prefKey, prefValue) {
    const updatePref = {
      key: prefKey,
      update: prefValue
    };
    return await PreferencesApi.patch(updatePref);
  }
};

export default DatabasePreferences;
